(function () {
  if (window.SpamigoBuilderCartNote) return;

  var BUILDER_NOTE_START = "----- Spa-Migo Builder Details START ";
  var BUILDER_NOTE_END = "----- Spa-Migo Builder Details END ";

  function save(note, updateUrl) {
    return fetch("/cart.js", {
      headers: {
        "Accept": "application/json"
      },
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to load cart before saving note.");
        return response.json();
      })
      .then(function (cart) {
        return fetch(updateUrl || "/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            note: merge(note, cart)
          })
        });
      });
  }

  function merge(note, cart) {
    var proposed = String(note || "");
    var current = String(cart && cart.note || "");
    var activeBundleIds = activeBuilderBundleIds(cart);
    var proposedBundleIds = builderBlockIds(proposed);
    var missingBlocks = builderBlocks(current).filter(function (block) {
      return activeBundleIds[block.bundleId] && !proposedBundleIds[block.bundleId];
    });

    if (!missingBlocks.length) return proposed;

    var lines = proposed.split(/\r?\n/);
    while (lines.length && !String(lines[lines.length - 1]).trim()) lines.pop();
    if (lines.length) lines.push("");
    missingBlocks.forEach(function (block, index) {
      if (index > 0) lines.push("");
      lines = lines.concat(block.lines);
    });
    return lines.join("\n");
  }

  function customerNote(note) {
    var lines = String(note || "").split(/\r?\n/);
    var kept = [];

    for (var i = 0; i < lines.length; i += 1) {
      var bundleId = builderNoteBundleId(lines[i]);
      if (!bundleId) {
        kept.push(lines[i]);
        continue;
      }

      i += 1;
      while (i < lines.length) {
        if (isBuilderNoteEndLine(lines[i])) break;
        i += 1;
      }
    }

    while (kept.length && !String(kept[0]).trim()) kept.shift();
    while (kept.length && !String(kept[kept.length - 1]).trim()) kept.pop();
    return kept.join("\n");
  }

  function scrubVisibleNoteFields(root) {
    var scope = root || document;
    Array.prototype.slice.call(scope.querySelectorAll("#mini-cart__notes, #CartSpecialInstructions, .js-main-cart__note")).forEach(function (field) {
      var clean = customerNote(field.value);
      if (field.value !== clean) field.value = clean;
    });
  }

  function activeBuilderBundleIds(cart) {
    var ids = Object.create(null);
    ((cart && cart.items) || []).forEach(function (item) {
      var id = cartItemBundleId(item);
      if (id) ids[id] = true;
    });
    return ids;
  }

  function cartItemBundleId(item) {
    if (!item || !item.properties) return "";
    if (Array.isArray(item.properties)) {
      for (var i = 0; i < item.properties.length; i += 1) {
        var property = item.properties[i];
        var key = property && (property[0] || property.name || property.key);
        if (key === "Builder Bundle ID" || key === "_Builder Bundle ID") {
          return String(property[1] || property.value || "");
        }
      }
      return "";
    }
    return String(item.properties["Builder Bundle ID"] || item.properties["_Builder Bundle ID"] || "");
  }

  function builderBlockIds(note) {
    var ids = Object.create(null);
    builderBlocks(note).forEach(function (block) {
      ids[block.bundleId] = true;
    });
    return ids;
  }

  function builderBlocks(note) {
    var lines = String(note || "").split(/\r?\n/);
    var blocks = [];

    for (var i = 0; i < lines.length; i += 1) {
      var bundleId = builderNoteBundleId(lines[i]);
      if (!bundleId) continue;

      var blockLines = [lines[i]];
      var hasEnd = false;
      i += 1;
      while (i < lines.length) {
        blockLines.push(lines[i]);
        if (isBuilderNoteEndLine(lines[i])) {
          hasEnd = true;
          break;
        }
        i += 1;
      }

      if (hasEnd) {
        blocks.push({
          bundleId: bundleId,
          lines: blockLines
        });
      }
    }

    return blocks;
  }

  function builderNoteBundleId(line) {
    var text = String(line || "");
    if (text.indexOf(BUILDER_NOTE_START) !== 0) return "";
    return text.slice(BUILDER_NOTE_START.length).replace(/\s*-+\s*$/, "").trim();
  }

  function isBuilderNoteEndLine(line) {
    return String(line || "").indexOf(BUILDER_NOTE_END) === 0;
  }

  window.SpamigoBuilderCartNote = {
    customerNote: customerNote,
    merge: merge,
    save: save,
    scrubVisibleNoteFields: scrubVisibleNoteFields
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scrubVisibleNoteFields(document);
    });
  } else {
    scrubVisibleNoteFields(document);
  }
  document.addEventListener("cart:refresh", function () {
    window.setTimeout(function () {
      scrubVisibleNoteFields(document);
    }, 0);
  });
})();
